import type { SettingSectionLayout } from '../settingLayout';

/** The "Cases and contracts" section: its group bands and their rows, in page order. */
export const CASES_SECTION: SettingSectionLayout = { anchor: 'cases', groups: [] };
